"use strict";
/**
 * 期货字段配置
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.qihuoItem = exports.ListQHItemConfig = exports.QiHuoItem = void 0;
var react_1 = __importDefault(require("react"));
var config_1 = require("../quote/config");
/**
 * 期货字段
 */
var QiHuoItem;
(function (QiHuoItem) {
    QiHuoItem[QiHuoItem["\u4EE3\u7801"] = 0] = "\u4EE3\u7801";
    QiHuoItem[QiHuoItem["\u4EE3\u7801\u5E26\u94FE\u63A5"] = 1] = "\u4EE3\u7801\u5E26\u94FE\u63A5";
    QiHuoItem[QiHuoItem["\u540D\u79F0"] = 2] = "\u540D\u79F0";
    QiHuoItem[QiHuoItem["\u5E02\u573A"] = 3] = "\u5E02\u573A";
    QiHuoItem[QiHuoItem["\u5E02\u573A\u540D\u79F0"] = 4] = "\u5E02\u573A\u540D\u79F0";
    QiHuoItem[QiHuoItem["\u884C\u60C5\u7EDF\u4E00\u94FE\u63A5"] = 5] = "\u884C\u60C5\u7EDF\u4E00\u94FE\u63A5";
    QiHuoItem[QiHuoItem["\u6DA8\u8DCC\u5E45"] = 6] = "\u6DA8\u8DCC\u5E45";
    QiHuoItem[QiHuoItem["\u6700\u65B0\u4EF7"] = 7] = "\u6700\u65B0\u4EF7";
    QiHuoItem[QiHuoItem["\u6DA8\u8DCC\u989D"] = 8] = "\u6DA8\u8DCC\u989D";
    QiHuoItem[QiHuoItem["\u4ECA\u5F00\u4EF7"] = 9] = "\u4ECA\u5F00\u4EF7";
    QiHuoItem[QiHuoItem["\u6700\u9AD8\u4EF7"] = 10] = "\u6700\u9AD8\u4EF7";
    QiHuoItem[QiHuoItem["\u6700\u4F4E\u4EF7"] = 11] = "\u6700\u4F4E\u4EF7";
    // "昨收价",
    QiHuoItem[QiHuoItem["\u6628\u7ED3"] = 12] = "\u6628\u7ED3";
    QiHuoItem[QiHuoItem["\u6210\u4EA4\u91CF"] = 13] = "\u6210\u4EA4\u91CF";
    QiHuoItem[QiHuoItem["\u6210\u4EA4\u989D"] = 14] = "\u6210\u4EA4\u989D";
    QiHuoItem[QiHuoItem["\u5185\u76D8_\u5356\u76D8"] = 15] = "\u5185\u76D8_\u5356\u76D8";
    QiHuoItem[QiHuoItem["\u5916\u76D8_\u4E70\u76D8"] = 16] = "\u5916\u76D8_\u4E70\u76D8";
    QiHuoItem[QiHuoItem["\u6301\u4ED3\u91CF"] = 17] = "\u6301\u4ED3\u91CF";
    QiHuoItem[QiHuoItem["\u4E70\u5165\u4EF7"] = 18] = "\u4E70\u5165\u4EF7";
    QiHuoItem[QiHuoItem["\u5356\u51FA\u4EF7"] = 19] = "\u5356\u51FA\u4EF7";
    QiHuoItem[QiHuoItem["\u4E70\u5165\u91CF"] = 20] = "\u4E70\u5165\u91CF";
    QiHuoItem[QiHuoItem["\u5356\u51FA\u91CF"] = 21] = "\u5356\u51FA\u91CF";
    QiHuoItem[QiHuoItem["\u73B0\u91CF"] = 22] = "\u73B0\u91CF";
    QiHuoItem[QiHuoItem["\u65E5\u589E"] = 23] = "\u65E5\u589E";
    QiHuoItem[QiHuoItem["\u671F\u6743\u884C\u6743\u4EF7"] = 24] = "\u671F\u6743\u884C\u6743\u4EF7";
    QiHuoItem[QiHuoItem["\u671F\u6743\u5269\u4F59\u671F\u9650"] = 25] = "\u671F\u6743\u5269\u4F59\u671F\u9650";
    // "期权标的券最新价",
    // "期权隐含波动率",
    // "期权折溢价率",
    // "期权T型报价行权价",
    // "认沽认购期权名称",
    // "认沽认购期权最新价",
    // "认沽认购期权涨跌幅",
    // "认沽认购期权涨跌额",
    // "认沽认购期权持仓量",
    // "认沽认购期权成交量",
    // "认沽认购期权隐含波动率",
    // "认沽认购期权折溢价率"
})(QiHuoItem || (exports.QiHuoItem = QiHuoItem = {}));
/**
 * 期货行情字段配置
 */
exports.ListQHItemConfig = (_a = {},
    _a[QiHuoItem.代码] = {
        fid: ['dm'],
        sort: "dm",
        value: function (data) {
            return {
                txt: data.dm,
                html: react_1.default.createElement("span", null, data.dm),
                color: '',
                source: data.dm
            };
        }
    },
    _a[QiHuoItem.代码带链接] = {
        fid: ['dm', 'sc'],
        sort: "dm",
        value: function (data) {
            return {
                source: '',
                txt: data.dm,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.sc, ".").concat(data.dm), target: "_blank" }, data.dm),
                color: '',
            };
        }
    },
    _a[QiHuoItem.名称] = {
        fid: ['name'],
        sort: "name",
        value: function (data) {
            return {
                txt: data.name,
                html: react_1.default.createElement("span", null, data.name),
                color: '',
                source: data.name
            };
        }
    },
    _a[QiHuoItem.行情统一链接] = {
        fid: ['name', 'sc', 'dm'],
        sort: "name",
        value: function (data) {
            return {
                source: "".concat(data.sc, ".").concat(data.dm),
                txt: "//quote.eastmoney.com/unify/r/".concat(data.sc, ".").concat(data.dm),
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.sc, ".").concat(data.dm), target: "_blank" }, data.name),
                color: '',
            };
        }
    },
    _a[QiHuoItem.市场] = {
        fid: ['sc'],
        sort: "sc",
        value: function (data) {
            return {
                txt: data.sc,
                html: react_1.default.createElement("span", null, data.sc),
                color: '',
                source: data.sc
            };
        }
    },
    _a[QiHuoItem.市场名称] = {
        fid: ['sc'],
        sort: "sc",
        value: function (data) {
            var sc_txt = formatNumberQhsc(data.sc);
            return {
                txt: sc_txt,
                html: react_1.default.createElement("span", null, sc_txt),
                color: '',
                source: sc_txt
            };
        }
    },
    _a[QiHuoItem.涨跌幅] = {
        fid: ['zdf'],
        sort: 'zdf',
        value: function (data) {
            return qihuoItem(data.zdf, -1, data.zdf, -1, '%', 2);
        }
    },
    _a[QiHuoItem.涨跌额] = {
        fid: ['zde', 'zsjd'],
        sort: 'zde',
        value: function (data) {
            return qihuoItem(data.zde, 0, data.zde, -1, '', data.zsjd);
        }
    },
    _a[QiHuoItem.最新价] = {
        fid: ['p', 'zdf', 'zsjd'],
        sort: 'p',
        value: function (data) {
            return qihuoItem(data.p, 0, data.zdf, -1, '', data.zsjd);
        }
    },
    _a[QiHuoItem.今开价] = {
        fid: ['o', 'zjsj', 'zsjd'],
        sort: 'o',
        value: function (data) {
            return qihuoItem(data.o, -1, data.o - data.zjsj, -1, '', data.zsjd);
        }
    },
    _a[QiHuoItem.期权行权价] = {
        fid: ['xqj', 'zsjd'],
        sort: 'xqj',
        value: function (data) {
            return qihuoItem(data.xqj, 0, 0, -1, '', data.zsjd);
        }
    },
    _a[QiHuoItem.最高价] = {
        fid: ['h', 'zjsj', 'zsjd'],
        sort: 'h',
        value: function (data) {
            return qihuoItem(data.h, -1, data.h - data.zjsj, -1, '', data.zsjd);
        }
    },
    _a[QiHuoItem.最低价] = {
        fid: ['l', 'zjsj', 'zsjd'],
        sort: 'l',
        value: function (data) {
            return qihuoItem(data.l, -1, data.l - data.zjsj, -1, '', data.zsjd);
        }
    },
    _a[QiHuoItem.昨结] = {
        fid: ['zjsj', 'zsjd'],
        sort: 'zjsj',
        value: function (data) {
            return qihuoItem(data.zjsj, -1, 0, -1, '', data.zsjd);
        }
    },
    _a[QiHuoItem.成交量] = {
        fid: ['vol'],
        sort: 'vol',
        value: function (data) {
            return qihuoItem(data.vol, -1, 0, 4, "", 2);
        }
    },
    _a[QiHuoItem.成交额] = {
        fid: ['cje'],
        sort: 'cje',
        value: function (data) {
            return qihuoItem(data.cje, -1, 0, 4, "", 2);
        }
    },
    _a[QiHuoItem.内盘_卖盘] = {
        fid: ['np'],
        sort: 'np',
        value: function (data) {
            return qihuoItem(data.np, -1, 0, -1);
        }
    },
    _a[QiHuoItem.外盘_买盘] = {
        fid: ['wp'],
        sort: 'wp',
        value: function (data) {
            return qihuoItem(data.wp, -1, 0, -1);
        }
    },
    _a[QiHuoItem.持仓量] = {
        fid: ['ccl'],
        sort: 'ccl',
        value: function (data) {
            return qihuoItem(data.ccl, -1, 0, -1);
        }
    },
    _a[QiHuoItem.买入价] = {
        fid: ['mrj', 'zjsj', 'zsjd'],
        sort: 'mrj',
        value: function (data) {
            return qihuoItem(data.mrj, -1, data.mrj - data.zjsj, -1, '', data.zsjd);
        }
    },
    _a[QiHuoItem.卖出价] = {
        fid: ['mcj', 'zjsj', 'zsjd'],
        sort: 'mcj',
        value: function (data) {
            return qihuoItem(data.mcj, -1, data.mcj - data.zjsj, -1, '', data.zsjd);
        }
    },
    _a[QiHuoItem.现量] = {
        fid: ['xs'],
        sort: 'xs',
        value: function (data) {
            return qihuoItem(data.xs, -1, 0, -1);
        }
    },
    _a[QiHuoItem.日增] = {
        fid: ['rz'],
        sort: 'rz',
        value: function (data) {
            return qihuoItem(data.rz, -1, data.rz, -1);
        }
    },
    _a[QiHuoItem.买入量] = {
        fid: ['mrl'],
        sort: 'mrl',
        value: function (data) {
            return qihuoItem(data.mrl, -1, 1, -1);
        }
    },
    _a[QiHuoItem.卖出量] = {
        fid: ['mcl'],
        sort: 'mcl',
        value: function (data) {
            return qihuoItem(data.mcl, -1, -1, -1);
        }
    },
    _a[QiHuoItem.期权剩余期限] = {
        fid: ['syr'],
        sort: 'syr',
        value: function (data) {
            return qihuoItem(data.syr, -1, 0, -1);
        }
    },
    _a);
/**
 * 转化行情数据为需要的格式
 * @param input 输入数据
 * @param fixed 缩小倍数并保留小数位数
 * @param colornumber 颜色 大于0红色 小于0 绿色 等于0 灰色 null不设置颜色
 * @param format_number 格式化数据 万 亿 万亿 并设置最大宽度
 * @param hz 后缀
 * @param tofixed 保留小数位数
 * @returns
 */
function qihuoItem(input, fixed, colornumber, format_number, hz, tofixed, fixed_tofixed) {
    if (input == undefined) {
        return {
            txt: '',
            color: '',
            html: react_1.default.createElement(react_1.default.Fragment, null, "-"),
            source: input
        };
    }
    if (input == '-') {
        return {
            txt: '-',
            color: '',
            html: react_1.default.createElement(react_1.default.Fragment, null, "-"),
            source: input
        };
    }
    var return_obj = {
        txt: input.toString(),
        color: 'price_draw',
        html: react_1.default.createElement(react_1.default.Fragment, null),
        source: input
    };
    //处理放大倍数
    if (typeof input == 'number' && fixed > 0) {
        return_obj.txt = (input / (Math.pow(10, fixed))).toFixed(fixed);
    }
    if (typeof input == 'number' && tofixed != undefined && tofixed > 0) {
        return_obj.txt = input.toFixed(tofixed);
    }
    if (typeof input == 'number' && fixed > 0 && fixed_tofixed != undefined && fixed_tofixed > 0) {
        return_obj.txt = (input / (Math.pow(10, fixed))).toFixed(fixed_tofixed);
    }
    //格式化
    if (typeof input == 'number' && format_number > 0) {
        return_obj.txt = (0, config_1.formatNumMaxWidth)(input, format_number, tofixed);
    }
    //颜色
    if (colornumber != null && colornumber > 0) {
        return_obj.color = 'price_up';
    }
    else if (colornumber != null && colornumber < 0) {
        return_obj.color = 'price_down';
    }
    else if (colornumber != null && colornumber == 0) {
        return_obj.color = 'price_draw';
    }
    else {
        return_obj.color = '';
    }
    //后缀
    if (hz != undefined) {
        return_obj.txt += hz;
    }
    return_obj.html = react_1.default.createElement("span", { className: return_obj.color }, return_obj.txt);
    return return_obj;
}
exports.qihuoItem = qihuoItem;
/**
 * 期货交易市场名称
 * @param value
 * @returns
 */
function formatNumberQhsc(value) {
    var obj = {
        '1': '上交所',
        '8': '中金所',
        '220': '中金所',
        '113': '上期所',
        '114': '大商所',
        '115': '郑商所',
        '116': '港交所',
        '142': '上期能源'
    };
    var markentname = '';
    if (value) {
        if (obj[value]) {
            markentname = obj[value];
        }
        else {
            markentname = '国际期货';
        }
    }
    return markentname;
}
